module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('rate-plan-blank-form', {
    attrs: {
      "submit-label": "Добавить тарифный план",
      "rate-plan": _vm.rate_plan,
      "errors": _vm.errors,
      "form-type": "add"
    },
    on: {
      "submit": _vm.processRatePlanForm
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7da43d03","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/rate_plan/RatePlanAddForm.vue
// module id = 678
// module chunks = 0